import { PersonalDataState } from './index';
import { MutationTree } from 'vuex';
import ContactRoom from "../interfaces/contactRoom";
import ContactPerson from "../interfaces/contactPerson";
import { toISO } from "@lib/converter/date";

export default {
    setContactRooms(state, rooms: ContactRoom[]) {
        state.rooms = rooms;
    },
    setContactPersons(state, persons: ContactPerson[]) {
        persons.forEach((person) => {
            person.birthDate = toISO(person.birthDate);
        })

        state.persons = persons;
    },
    setUseContactInfo(state, useContactPerson: number | null) {
        state.useContactInfo = useContactPerson;
    },
    setDriverCount(state, driverCount: number) {
        state.driver.driverCount = driverCount;
    },
    setMainDriver(state, [rIndex, pIndex]) {
        if (state.driver.driverCount >= 1) {
            state.rooms[rIndex].mainDriver = state.rooms[rIndex].mainDriver === null ? pIndex : null;
        }
    },
    setDriverIsValid(state, isValid: boolean) {
        state.driver.isValid = isValid
    },
    resetContactPersons(state) {
        state.persons = state.defaultPersons;
    },
    resetDriverState(state) {
        state.driver.driverCount = 0;
        state.driver.isValid = true;
    },
    setDefaultPersons(state, persons: ContactPerson[]) {
        persons.forEach((person) => {
            person.birthDate = toISO(person.birthDate);
        })

        state.defaultPersons = persons;
    },
    setContactInfoCountry(state, country: string) {
        state.contactInfo.country = country;

        state.persons.forEach((person) => {
            person.nationality = country
        });
    },
    setContactInfoCountryIso2(state, iso2: string) {
        state.contactInfo.iso2 = iso2;

        state.persons.forEach((person) => {
            person.iso2 = iso2;
        });
    },
    setContactInfoDialCode(state, dialCode: number) {
        state.contactInfo.dialCode = '+' + dialCode;
    },
    updatePhoneWithDialCode(state) {
        if (state.contactInfo.dialCode !== '+0') {
            const phone = state.contactInfo.phone;
            const dialCode = state.contactInfo.dialCode;

            state.contactInfo.phoneWithDialCode = dialCode + (phone.startsWith('0') ? phone.slice(1) : phone);
        } else {
            state.contactInfo.phoneWithDialCode = '';
        }
    }
} as MutationTree<PersonalDataState>
